$(document).ready(function () {
  $(window).on("load", function () {
    
    const rc_SellingPlan = $(".rc-selling-plans-dropdown__select").val();
    //$('.product-form [name="selling_plan"]').val(rc_SellingPlan);
  });

  // $(document).on(
  //   "change",
  //   ".rc-button-group__options .rc-radio__input",
  //   function () {
  //     window.updateRechargeSelect();
  //     console.log("rc input changed---");
  //   }
  // );
  var variant_id = $(".product-variant-id").val(),
    variant_sellingHtml = $(`.variant_selling[data-id='${variant_id}']`).html();
  const rechargeWidget = setInterval(function () {
    $(".subscription-radio")
      .find(".discount-label")
      .addClass("sunscription_radio");
    $('.sunscription_radio:contains("15%")').each(function () {
      $(this).html($(this).html().split("15%").join(""));
    });
    $(".subscription-radio .price-label").html(variant_sellingHtml);
    // console.log("variant_id<><><><>",variant_id,"rechargeWidget============",rechargeWidget,variant_sellingHtml);
    if ($(".rc-widget").length > 0) {
      clearInterval(rechargeWidget);
    }
  }, 50);

  const params = new URLSearchParams(window.location.search);

  if (params.get('open-cart') === 'true') {
    const drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

    const accordions = document.querySelectorAll(
    ".product__accordion details"
  );

  // Open first accordion
  // if (accordions.length > 0) {
  //   accordions[0].open = true;
  // }

  accordions.forEach((accordion) => {
    accordion.addEventListener("toggle", function () {
      if (this.open) {
        accordions.forEach((item) => {
          if (item !== this) {
            item.removeAttribute("open");
          }
        });
      }
    });
  });

});
window.updateRechargeSelect = (variant) => {

    var radioButtons = $(".product-form__input input[type=radio]"),
      selectedRadioIndex = radioButtons.index(radioButtons.filter(":checked")),
      value = $(".rc-selling-plans-dropdown__select option")
        .eq(selectedRadioIndex)
        .attr("value");
    console.log(
      "selectedIndex",
      selectedRadioIndex,
      value,
      $(".rc-selling-plans-dropdown__select")
    );
    var variant_title = radioButtons.eq(selectedRadioIndex).val()
    console.log(variant_title,"--variant_title--");
  
   if (!variant_title.includes("Chews")) {
    if(value){
      console.log("fdsfdf");
    setTimeout(function () {
      $(".rc-selling-plans-dropdown__select").val(value).change();
      $(".delivery-select").val(value).change();
      $('[name="selling_plan"]').val(value);
    }, 0);
  }else{
     console.log("test11");
    setTimeout(function () {
       const params = new URLSearchParams(window.location.search);
    const sellingPlanId = params.get('selling_plan');
     $('[name="selling_plan"]').val(sellingPlanId);
    },1000);
  }
}

    // $(".rc-selling-plans-dropdown__select").get(0).selectedIndex = parseInt(selectedRadioIndex);
};
// recharge widget js 
const interval = setInterval(() => {
  const root = document
    .querySelector('recharge-subscription-widget')?.shadowRoot
    ?.querySelector('rc-selling-plans')?.shadowRoot;

  if (!root) return;

  const discounts = root.querySelectorAll('.rc-plans-button__discount');
  discounts.forEach(el => {
    el.style.setProperty('display', 'none', 'important');
  });


  const buttons = root.querySelectorAll('.rc-plans-button');
  if (buttons.length > 0) {
    buttons.forEach(btn => {
      btn.style.setProperty('background', '#ffffff', 'important');
      btn.style.setProperty('color', '#121212', 'important');
    });
  }

  const subscriptionInput = root.querySelector(
    'input[type="radio"][value="subscription"]'
  );

  if (subscriptionInput && !subscriptionInput.checked) {
   subscriptionInput.click(); // 🔥 trigger selection
    console.log('Subscription selected');
  }
  

  if (buttons.length > 0 && subscriptionInput) {
    clearInterval(interval);
    console.log('Interval cleared');
  }

}, 50);
const rootObserver = setInterval(() => {
  const root = document
    .querySelector('recharge-subscription-widget')?.shadowRoot;

  if (!root) return;

  const updateText = () => {
    const label = root.querySelector(
      '.rc-purchase-option__subscription .rc-purchase-option__label'
    );

    if (!label) return;

    const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT, null);

    let node;
    while (node = walker.nextNode()) {
      // if (node.nodeValue.includes('Subscribe & Save') &&
      //     !node.nodeValue.includes('15%')) {
      //   node.nodeValue = 'Auto Delivery <span>Save 15%</span>';
      // }
      if (
        node.nodeValue.includes('Subscribe & Save') &&
        !node.nodeValue.includes('15%')
      ) {
        const wrapper = document.createElement('span');
        wrapper.innerHTML = `Auto Delivery <span class="save-badge">Save 15%</span>`;
        
        node.parentNode.replaceChild(wrapper, node);
      }
    }
  };

  updateText();

  const observer = new MutationObserver(updateText);
  observer.observe(root, { childList: true, subtree: true });

  clearInterval(rootObserver);
}, 100);

// document.addEventListener('click', async function (e) {

//   const button = e.target.closest('.add-cart-selling');
//   if (!button) return;

//   document.querySelector(".cart__checkout-button").disabled = true;
//   button.innerHTML = button.innerHTML;

//   const wrapper = button.closest('.cart-selling-plan');

//   const line = wrapper.dataset.line;
//   const variantId = wrapper.dataset.variantid;
//   const productId = wrapper.dataset.productid;
//   const sellingPlanId = wrapper.querySelector('.selling-plan-select option[selected]').value;
//   console.log(sellingPlanId,"---sellingPlanId--");

//   const freeVariantIds =  window.freeGifts?.[variantId] || [];
//  let shouldAddGift = true;
//  let currentGiftCount = 0;
//   try {

     
//         const cart = await fetch('/cart.js').then(r => r.json());
//         const turboflexProduct = await fetch('/products/turboflex.js')
//                         .then(res => res.json());


//         const turboflexVariants = turboflexProduct.variants;

//         currentGiftCount = Math.max(
//           ...freeVariantIds.map(id => {
//             const variant = turboflexVariants.find(v => v.id == id);

//             if (!variant) return 0;

//             const match = variant.title.match(/\d+/);

//             return match ? Number(match[0]) : 0;
//           })
//         );

//                     const existingGift = cart.items.find(item =>
//                         item.handle === "turboflex" &&
//                         item.properties?._free_gift === "true"
//                       );
//             const existingCount = existingGift
//         ? Number(existingGift.variant_title.match(/\d+/)?.[0] || 0)
//         : 0;
//       if (currentGiftCount > existingCount) {
//         let updates = {};

//         cart.items.forEach(item => {
//           if (
//             item.properties?._free_gift === 'true' &&
//             item.handle === 'turboflex'
//           ) {
//             updates[item.key] = 0;
//           }
//         });

//         if (Object.keys(updates).length > 0) {
//           await fetch('/cart/update.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({ updates })
//           });
//         }
//           console.log('old turboflex removed');
//         shouldAddGift = true;
//       }else{
//         shouldAddGift = false;     
//       }
//       console.log(shouldAddGift,"---shouldAddGift--");

//     // 1. Remove current item
//     await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         line: line,
//         quantity: 0
//       })
//     });

//     // 2. Check existing gifts
//     const results = await Promise.all(
//       freeVariantIds.map(id => isFreeProductInCart1(id))
//     );

//     // 3. Build multi-item formData
//     const formData = new FormData();

//     // MAIN PRODUCT (subscription)
//     formData.append('items[0][id]', variantId);
//     formData.append('items[0][quantity]', 1);
//     formData.append('items[0][selling_plan]', sellingPlanId);
//     formData.append('items[0][properties][_gift_id]', 'freegift_' + variantId);
//     formData.append('items[0][properties][_main_product]', 'main_'+productId); 
//     formData.append('items[0][properties][_gifts_product]', 'allgift_'+productId);  

//     // FREE GIFTS
//     //if (window.isCustomerLoggedIn && !window.customerAlreadyReceivedGift) {
//     if (!window.customerAlreadyReceivedGift) {
//     let giftIndex = 1;

//     freeVariantIds.forEach((id, index) => {
//       if (!results[index] && shouldAddGift || !results[index] && currentGiftCount == 0 ) {
//         formData.append(`items[${giftIndex}][id]`, id);
//         formData.append(`items[${giftIndex}][quantity]`, 1);
//         formData.append(`items[${giftIndex}][properties][_free_gift]`, 'true');
//         formData.append(`items[${giftIndex}][properties][_gift_id]`, 'freegift_' + variantId);
//         formData.append(`items[${giftIndex}][properties][_gifts_product]`, 'allgift_'+productId);
//         giftIndex++;
//       }
//     });
//   }
 

//     // 4. Add to cart (main + gifts together)
//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       body: formData
//     });

//     const data = await response.json();
//     console.log(data, "--data-with-gifts--");

//     // 5. Refresh cart
//     window.refreshCart();

//   } catch (error) {
//     console.error('Error updating cart:', error);
//   }

//   // 6. Enable checkout again
//   document.querySelector(".cart__checkout-button").disabled = false;
// });
document.addEventListener('click', async function (e) {
  const button = e.target.closest('.add-cart-selling');
  if (!button) return;

  // Prevent double click
  if (button.dataset.processing === 'true') return;
  button.dataset.processing = 'true';

  const checkoutButton = document.querySelector('.cart__checkout-button');

  if (checkoutButton) {
    checkoutButton.disabled = true;
  }

  try {
    const wrapper = button.closest('.cart-selling-plan');

    if (!wrapper) {
      console.error('Cart selling plan wrapper not found');
      return;
    }

    const line = wrapper.dataset.line;
    const variantId = wrapper.dataset.variantid;
    const productId = wrapper.dataset.productid;

    // IMPORTANT:
    // Use current selected selling plan value
    const sellingPlanSelect = wrapper.querySelector('.selling-plan-select');

    const sellingPlanId = sellingPlanSelect?.value;

    console.log('Selling Plan:', sellingPlanId);
    console.log('Variant:', variantId);
    console.log('Product:', productId);
    console.log('Line:', line);

    if (!sellingPlanId) {
      console.error('Selling plan not selected');
      return;
    }

    const freeVariantIds = window.freeGifts?.[variantId] || [];

    console.log('Free Gift Variants:', freeVariantIds);

    /*
    |--------------------------------------------------------------------------
    | STEP 1: GET CURRENT CART
    |--------------------------------------------------------------------------
    */

    let cart = await fetch('/cart.js', {
      cache: 'no-store'
    }).then(res => res.json());

    console.log('Initial Cart:', cart);


    /*
    |--------------------------------------------------------------------------
    | STEP 2: REMOVE CURRENT SUBSCRIPTION LINE
    |--------------------------------------------------------------------------
    */

    if (line) {
      console.log('Removing current cart line:', line);

      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: 0
        })
      });

      const removeData = await removeResponse.json();

      console.log('Remove Response:', removeData);

      if (!removeResponse.ok) {
        throw new Error(
          removeData.description ||
          removeData.message ||
          'Unable to remove old cart item'
        );
      }
    }


    /*
    |--------------------------------------------------------------------------
    | STEP 3: GET FRESH CART AFTER REMOVE
    |--------------------------------------------------------------------------
    */

    cart = await fetch('/cart.js', {
      cache: 'no-store'
    }).then(res => res.json());

    console.log('Cart After Removing Current Line:', cart);


    /*
    |--------------------------------------------------------------------------
    | STEP 4: CHECK IF MAIN VARIANT STILL EXISTS
    |--------------------------------------------------------------------------
    */

    const sameMainVariant = cart.items.filter(item => {
      return Number(item.variant_id) === Number(variantId);
    });

    console.log(
      'Same Main Variant Still In Cart:',
      sameMainVariant
    );

    /*
    |--------------------------------------------------------------------------
    | STEP 5: REMOVE DUPLICATE MAIN VARIANT IF IT STILL EXISTS
    |--------------------------------------------------------------------------
    */

    if (sameMainVariant.length > 0) {
      console.warn(
        'Main variant still exists after line removal. Removing duplicates...'
      );

      const updates = {};

      sameMainVariant.forEach(item => {
        updates[item.key] = 0;
      });

      if (Object.keys(updates).length > 0) {
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            updates
          })
        });

        const updateData = await updateResponse.json();

        console.log(
          'Duplicate Main Variant Removed:',
          updateData
        );

        if (!updateResponse.ok) {
          throw new Error(
            updateData.description ||
            updateData.message ||
            'Unable to remove duplicate main product'
          );
        }
      }
    }


    /*
    |--------------------------------------------------------------------------
    | STEP 6: GET TURBOFLEX PRODUCT
    |--------------------------------------------------------------------------
    */

    let currentGiftCount = 0;

    if (freeVariantIds.length > 0) {

      const turboflexResponse =
        await fetch('/products/turboflex.js', {
          cache: 'no-store'
        });

      const turboflexProduct =
        await turboflexResponse.json();

      const turboflexVariants =
        turboflexProduct.variants || [];

      /*
      |--------------------------------------------------------------------------
      | FIND HIGHEST GIFT COUNT
      |--------------------------------------------------------------------------
      */

      currentGiftCount = Math.max(
        0,
        ...freeVariantIds.map(id => {

          const variant = turboflexVariants.find(
            v => Number(v.id) === Number(id)
          );

          if (!variant) return 0;

          const match =
            variant.title?.match(/\d+/);

          return match
            ? Number(match[0])
            : 0;
        })
      );
    }

    console.log(
      'Current Gift Count:',
      currentGiftCount
    );


    /*
    |--------------------------------------------------------------------------
    | STEP 7: CHECK EXISTING TURBOFLEX GIFT
    |--------------------------------------------------------------------------
    */

    const existingGift = cart.items.find(item =>
      item.handle === 'turboflex' &&
      item.properties?._free_gift === 'true'
    );

    const existingCount = existingGift
      ? Number(
          existingGift.variant_title
            ?.match(/\d+/)?.[0] || 0
        )
      : 0;

    console.log(
      'Existing Gift Count:',
      existingCount
    );


    /*
    |--------------------------------------------------------------------------
    | STEP 8: REMOVE OLD TURBOFLEX IF NEW GIFT IS HIGHER
    |--------------------------------------------------------------------------
    */

    let shouldAddGift = true;

    if (currentGiftCount > existingCount) {

      console.log(
        'New gift is higher -> removing old TurboFlex'
      );

      const updates = {};

      cart.items.forEach(item => {

        if (
          item.handle === 'turboflex' &&
          item.properties?._free_gift === 'true'
        ) {
          updates[item.key] = 0;
        }

      });

      if (Object.keys(updates).length > 0) {

        const giftRemoveResponse =
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              updates
            })
          });

        const giftRemoveData =
          await giftRemoveResponse.json();

        console.log(
          'Old TurboFlex Removed:',
          giftRemoveData
        );

        if (!giftRemoveResponse.ok) {
          throw new Error(
            giftRemoveData.description ||
            giftRemoveData.message ||
            'Unable to remove old TurboFlex gift'
          );
        }
      }

      shouldAddGift = true;

    } else {

      console.log(
        'Existing gift is same/higher -> keep existing gift'
      );

      shouldAddGift = false;
    }


    /*
    |--------------------------------------------------------------------------
    | STEP 9: GET FRESH CART AGAIN
    |--------------------------------------------------------------------------
    */

    cart = await fetch('/cart.js', {
      cache: 'no-store'
    }).then(res => res.json());

    console.log(
      'Fresh Cart Before Add:',
      cart
    );


    /*
    |--------------------------------------------------------------------------
    | STEP 10: CHECK GIFTS AGAIN
    |--------------------------------------------------------------------------
    */

    const giftResults = await Promise.all(
      freeVariantIds.map(id =>
        isFreeProductInCart1(id)
      )
    );

    console.log(
      'Gift Already In Cart:',
      giftResults
    );


    /*
    |--------------------------------------------------------------------------
    | STEP 11: BUILD FORM DATA
    |--------------------------------------------------------------------------
    */

    const formData = new FormData();

    /*
    MAIN PRODUCT
    */

    formData.append(
      'items[0][id]',
      variantId
    );

    formData.append(
      'items[0][quantity]',
      '1'
    );

    formData.append(
      'items[0][selling_plan]',
      sellingPlanId
    );

    formData.append(
      'items[0][properties][_gift_id]',
      'freegift_' + variantId
    );

    formData.append(
      'items[0][properties][_main_product]',
      'main_' + productId
    );

    formData.append(
      'items[0][properties][_gifts_product]',
      'allgift_' + productId
    );


    /*
    |--------------------------------------------------------------------------
    | STEP 12: ADD FREE GIFTS
    |--------------------------------------------------------------------------
    */

    let giftIndex = 1;

    if (
      !window.customerAlreadyReceivedGift &&
      freeVariantIds.length > 0
    ) {

      freeVariantIds.forEach((id, index) => {

        const giftAlreadyExists =
          giftResults[index];

        const shouldAddThisGift =
          !giftAlreadyExists &&
          (
            shouldAddGift ||
            currentGiftCount === 0
          );

        if (shouldAddThisGift) {

          console.log(
            'Adding gift variant:',
            id
          );

          formData.append(
            `items[${giftIndex}][id]`,
            id
          );

          formData.append(
            `items[${giftIndex}][quantity]`,
            '1'
          );

          formData.append(
            `items[${giftIndex}][properties][_free_gift]`,
            'true'
          );

          formData.append(
            `items[${giftIndex}][properties][_gift_id]`,
            'freegift_' + variantId
          );

          formData.append(
            `items[${giftIndex}][properties][_gifts_product]`,
            'allgift_' + productId
          );

          giftIndex++;
        }

      });
    }


    /*
    |--------------------------------------------------------------------------
    | STEP 13: LOG EVERYTHING BEFORE ADD
    |--------------------------------------------------------------------------
    */

    console.log(
      'Adding Main Variant:',
      variantId
    );

    console.log(
      'Selling Plan:',
      sellingPlanId
    );

    console.log(
      'Gift Count:',
      giftIndex - 1
    );


    /*
    |--------------------------------------------------------------------------
    | STEP 14: ADD MAIN PRODUCT + GIFTS
    |--------------------------------------------------------------------------
    */

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    });

    const data = await response.json();

    console.log(
      'ADD CART RESPONSE:',
      data
    );


    /*
    |--------------------------------------------------------------------------
    | STEP 15: HANDLE 422 / OTHER ERRORS
    |--------------------------------------------------------------------------
    */

    if (!response.ok) {

      console.error(
        'Cart Add Error:',
        data
      );

      throw new Error(
        data.description ||
        data.message ||
        data.errors ||
        `Cart add failed (${response.status})`
      );
    }


    /*
    |--------------------------------------------------------------------------
    | STEP 16: REFRESH CART
    |--------------------------------------------------------------------------
    */

    console.log(
      'Product + Gifts Added Successfully'
    );

    if (typeof window.refreshCart === 'function') {
      await window.refreshCart();
    } else {
      window.location.reload();
    }


  } catch (error) {

    console.error(
      'Subscription Cart Error:',
      error
    );

  } finally {

    /*
    |--------------------------------------------------------------------------
    | ENABLE BUTTON
    |--------------------------------------------------------------------------
    */

    button.dataset.processing = 'false';

    if (checkoutButton) {
      checkoutButton.disabled = false;
    }

  }

});
// document.addEventListener('click', async function (e) {

//       const remove_button = e.target.closest('.cart-remove-button');
//       if (!remove_button) return;
//       document.querySelector(".cart__checkout-button").disabled = true;
//         const line = remove_button.dataset.index;
//         console.log(remove_button,"-remove_button-",line,"---line");
//       const product_id = remove_button.getAttribute("data-product-id");
//       try {
//         const cart = await fetch('/cart.js').then(res => res.json());
//         console.time('cart-fetch');
//         const currentItem = cart.items[line - 1];

//         if (!currentItem) return;

//         const bundleId = currentItem.properties?._gift_id;
//         console.log(bundleId);

//         let updates = {};
//   const mainProductKey = 'main_' + product_id;
//       const mainProducts = cart.items.filter(
//         item => item.properties?._main_product === mainProductKey
//       );
//       const isMainProduct = !!currentItem.properties?._main_product;
//     const giftsProduct = currentItem.properties?._gifts_product;
//     console.log("giftsProduct-----",giftsProduct,"-----",isMainProduct);

//     console.log(mainProducts.length, '--main product count');
//       if (isMainProduct) {
//           //  Loop through cart items
//           if(mainProducts.length == 1){
//           cart.items.forEach((item, i) => {
//             console.log(item.properties?._main_product);
//             if (
//               item.properties?._free_gift === 'true' &&
//               item.properties?._gifts_product === giftsProduct
//             ) {
//               updates[item.key] = 0;
//             }
//           });
//         }else{
//           cart.items.forEach((item, i) => {
//             if (
//               item.properties?._free_gift === 'true' &&
//               item.properties?._gift_id === bundleId &&
//               item.properties?._gifts_product === giftsProduct &&
//               item.handle === 'turboflex'
//             ) {
//               updates[item.key] = 0;
//             }
//           });
//         }
//       }
//         // 3. Fallback (if no bundle, just remove clicked)
//         if (Object.keys(updates).length === 0) {
//           updates[currentItem.key] = 0;
//         }
//       console.log(updates,"--updates")
//       console.time('cart-update');

//         await fetch('/cart/update.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ updates })
//         });

//         window.refreshCart();
//         setTimeout(function(){
//           document.querySelector(".cart__checkout-button").disabled = false;
//         }, 3000)

//       } catch (error) {
//         console.error('Remove error:', error);
//       }
// })
// document.addEventListener('click', async function (e) {

//   const remove_button = e.target.closest('.remove');
//   if (!remove_button) return;

//   e.preventDefault();

//   document.querySelector(".cart__checkout-button").disabled = true;

//   try {

//     const line = Number(remove_button.dataset.index);
//     const cart = await fetch('/cart.js').then(res => res.json());

//     const currentItem = cart.items[line - 1];
//     if (!currentItem) return;

//     const product_id = remove_button.getAttribute("data-product-id");
//     const mainProductKey = 'main_' + product_id;

//     const bundleId = currentItem.properties?._gift_id;
//     const giftsProduct = currentItem.properties?._gifts_product;

//     const updates = {};

//     const isMainProduct = !!currentItem.properties?._main_product;

//     // Remove clicked item
//     updates[currentItem.key] = 0;

//     // If main product remove
//     if (isMainProduct) {

//       const mainProducts = cart.items.filter(
//         item => item.properties?._main_product === mainProductKey
//       );
      

//       // Last main product => remove all gifts
//       if (mainProducts.length === 1) {

//         cart.items.forEach(item => {
//           if (
//             item.properties?._free_gift === 'true' &&
//             item.properties?._gifts_product === giftsProduct
//           ) {
//             updates[item.key] = 0;
//           }
//         });

//       } else {

//         // Remove only TurboFlex linked to this bundle
//         cart.items.forEach(item => {
//           if (
//             item.properties?._free_gift === 'true' &&
//             item.properties?._gift_id === bundleId &&
//             item.properties?._gifts_product === giftsProduct &&
//             item.handle === 'turboflex'
//           ) {
//             updates[item.key] = 0;
//           }
//         });

//       }
//     }

//     console.log('updates', updates);

//     await fetch('/cart/update.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({ updates })
//     });

//     // Fresh cart after removal
//     const updatedCart = await fetch('/cart.js').then(res => res.json());

//     const remainingMainProducts = updatedCart.items.filter(
//       item => item.properties?._main_product
//     );
//     //console.log(remainingMainProducts,"---remainingMainProducts--",remainingMainProducts.length);

//     // Add TurboFlex for largest remaining variant
//     if (remainingMainProducts.length > 0) {

//       const largestItem = remainingMainProducts.reduce((max, item) =>
//         Number(item.variant_id) > Number(max.variant_id)
//           ? item
//           : max
//       );

//       const variantId = String(largestItem.variant_id);
//       console.log(variantId,"---variantId--");

//       const turboflexId =
//         window.freeGifts?.[variantId]?.[0];

//         console.log(turboflexId,"--turboflexId--");

//       if (turboflexId) {

//         const productId =
//           largestItem.properties?._main_product.replace('main_', '');

//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({
//             items: [{
//               id: turboflexId,
//               quantity: 1,
//               properties: {
//                 _free_gift: 'true',
//                 _gift_id: 'freegift_' + variantId,
//                 _gifts_product: 'allgift_' + productId
//               }
//             }]
//           })
//         });

//         console.log('TurboFlex Added', turboflexId);
//       }
//     }

//     window.refreshCart();

//   } catch (error) {
//     console.error('Remove error:', error);
//   } finally {

//     setTimeout(() => {
//       document.querySelector(".cart__checkout-button").disabled = false;
//     }, 1000);

//   }

// });

document.addEventListener('click', async function (e) {

  const remove_button = e.target.closest('.remove');
  if (!remove_button) return;

  e.preventDefault();

  const checkoutBtn = document.querySelector(".cart__checkout-button");
  if (checkoutBtn) checkoutBtn.disabled = true;

  try {

    const line = Number(remove_button.dataset.index);

    let cart = await fetch('/cart.js').then(res => res.json());

    const currentItem = cart.items[line - 1];

    if (!currentItem) return;


    const updates = {};

    // remove clicked item only
    updates[currentItem.key] = 0;


    console.log("Removing:", currentItem);


    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type':'application/json'
      },
      body: JSON.stringify({
        updates
      })
    });



    // get latest cart after remove
    cart = await fetch('/cart.js').then(res => res.json());


    // const remainingMainProducts = cart.items.filter(item =>
    //   item.properties?._main_product
    // );
    const remainingMainProducts = cart.items.filter(item =>
  item.properties?._free_gift !== "true" &&
  (
    item.properties?._main_product ||
    window.ontimefreeGifts1?.[String(item.variant_id)]
  )
);


    console.log(
      "Remaining Main Products",
      remainingMainProducts
    );



    /*
      ===============================
      GIFT CHECK
      ===============================
    */


    const giftUpdates = {};


    const giftItems = cart.items.filter(item =>
      item.properties?._free_gift === 'true'
    );



    for (const gift of giftItems) {


      let giftNeeded = false;


      for (const main of remainingMainProducts) {


        // const allowedGifts =
        //   window.freeGifts?.[String(main.variant_id)] || [];
        const allowedGifts = [
  ...(window.freeGifts?.[String(main.variant_id)] || []),
  ...(window.ontimefreeGifts1?.[String(main.variant_id)] || [])
];


        if (
          allowedGifts.includes(Number(gift.variant_id))
        ) {

          giftNeeded = true;
          break;

        }

      }



      // no remaining product requires this gift
      if (!giftNeeded) {

        giftUpdates[gift.key] = 0;

      }


    }



    if(Object.keys(giftUpdates).length){

      console.log(
        "Removing unused gifts",
        giftUpdates
      );


      await fetch('/cart/update.js', {
        method:'POST',
        headers:{
          'Content-Type':'application/json'
        },
        body:JSON.stringify({
          updates:giftUpdates
        })
      });

    }



    /*
      ===============================
      TURBOFLEX CHECK
      ===============================
    */


    cart = await fetch('/cart.js').then(res=>res.json());


    const mainProducts = cart.items.filter(item =>
      item.properties?._main_product &&
    item.selling_plan_allocation
      );

  console.log("Turbo main products", mainProducts);

    if(mainProducts.length){


      // find largest supply variant
      const largestItem =
        mainProducts.reduce((max,item)=>{


          const maxQty =
            Number(
              max.variant_title?.match(/\d+/)?.[0] || 0
            );


          const itemQty =
            Number(
              item.variant_title?.match(/\d+/)?.[0] || 0
            );


          return itemQty > maxQty ? item : max;


        });



      const variantId =
        String(largestItem.variant_id);
        console.log(variantId,"--variantId---");



      const turboId =
        window.freeGifts?.[variantId]?.[0];



      if(turboId){


        const existingTurbo =
          cart.items.find(item =>
            item.handle === "turboflex" &&
            item.properties?._free_gift === "true"
          );



        if(!existingTurbo){


          await fetch('/cart/add.js',{
            method:'POST',
            headers:{
              'Content-Type':'application/json'
            },
            body:JSON.stringify({

              items:[{

                id:turboId,

                quantity:1,

                properties:{

                  _free_gift:'true',

                  _gift_id:
                    'freegift_'+variantId,


                  _gifts_product:
                    'allgift_'+
                    largestItem.properties._main_product
                      .replace('main_','')

                }

              }]

            })

          });


          console.log(
            "TurboFlex Added",
            turboId
          );


        }

      }

    }



    window.refreshCart();



  } catch(err){

    console.error(
      "Remove error",
      err
    );


  } finally {


    setTimeout(()=>{

      if(checkoutBtn)
        checkoutBtn.disabled=false;

    },1000);


  }


});

document.addEventListener("click", async function (event) {
  const el = event.target.closest(".add_fbt_item");
  if (!el) return;

  document.querySelector(".cart__checkout-button").disabled = true;

  const mainProductVariantId = el.getAttribute("data-id");
  const product_id = el.getAttribute("data-product-id");

  // Gift mapping
  const giftMap = window.ontimefreeGifts1 || {};
  const oneTimeGifts = giftMap[mainProductVariantId] || [];

  // Check if gifts already exist
  const results = await Promise.all(
    oneTimeGifts.map(giftId => onetimeFreeProductInCart1(giftId))
  );

  const formData = new FormData();

  // ---------------- Main Product ----------------
  formData.append("items[0][id]", mainProductVariantId);
  formData.append("items[0][quantity]", 1);
  formData.append("items[0][properties][_gift_id]", "freegift_" + mainProductVariantId);
  formData.append("items[0][properties][_main_product]", "main_" + product_id);
  formData.append("items[0][properties][_gifts_product]", "allgift_" + product_id);

  // ---------------- Gifts ----------------
  let giftIndex = 1;

  oneTimeGifts.forEach((giftId, index) => {
    if (!results[index]) {
      formData.append(`items[${giftIndex}][id]`, giftId);
      formData.append(`items[${giftIndex}][quantity]`, 1);
      formData.append(`items[${giftIndex}][properties][_free_gift]`, "true");
      formData.append(`items[${giftIndex}][properties][_gift_id]`, "freegift_" + mainProductVariantId);
      formData.append(`items[${giftIndex}][properties][_gifts_product]`, "allgift_" + product_id);
      giftIndex++;
    }
  });

  // Debug
  console.log([...formData.entries()]);

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: formData
    });

    const data = await response.json();

    console.log(data);

    if (data.status) {
      console.error(data);
      return;
    }

    if (window.refreshCart) {
      window.refreshCart();
    }

  } catch (e) {
    console.error(e);
  } finally {
    document.querySelector(".cart__checkout-button").disabled = false;
  }
});
function multipleATC(item_array, el = null) {
  this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  var items = [];

  item_array.forEach((item) => {
    let myObj = {
      id: item.id,
      quantity: item.quantity,
      properties: item.properties,
    };
    items.push(myObj);
  });

  let formData = {
    items: items,
  };


  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((items) => {
      
      setTimeout(() => {
        window.refreshCart();    
      });

    })
    .catch((error) => {
     
    });
}
function clearCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("load-cart");
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(() => {
    // Refresh cart drawer
    window.refreshCart();
  })
  .catch(err => console.error('Error clearing cart:', err));
}
function applyDiscountCode() {
  const input = document.getElementById('CartPromoCode');
  const error = document.getElementById('PromoError');
  const code = input.value.trim();

  if (!code) {
    error.style.display = 'block';
    error.innerText = 'Please enter a promo code';
    return;
  }

  error.style.display = 'none';

  // ✅ Save in localStorage
  localStorage.setItem('applied_discount', code);

  // Optional UI feedback
  error.style.display = 'block';
  error.style.color = 'green';
  error.innerText = 'Promo code applied';
}
// refresh cart
window.refreshCart = () => {
  fetch('/cart?section_id=cart-drawer')
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      // console.log("html:", html);
      const count = parseInt(
        html.querySelector("cart-drawer-items")?.getAttribute("item_count") ||
          "0",
        10
      );
      // console.log("count:", count);
      const selectors = [
        ".drawer__inner",
        "cart-drawer-items",
        ".cart-drawer__footer"
      ];
      //document.querySelector(".cart__checkout-button.button").disabled = !1;
      const checkoutButton = document.querySelector(
        "button.cart__checkout-button"
      );
      
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        if (count > 0) {
          cartDrawer.classList.remove("is-empty");
          cartDrawer.classList.add("active");
          document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
            bubble.classList.remove("hidden");
          });
        } else {
          cartDrawer.classList.add("is-empty");
          document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
            bubble.classList.add("hidden");
          });
        }
      }
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
      }
      document
        .querySelectorAll(".cart-count-bubble span:first-child")
        .forEach((bubble) => {
          bubble.textContent = count;
        });
      try {
      } catch (err) {
        console.error("Error updating widgets:", err);
      }
    })
    .catch((error) => {
      console.error("Error refreshing cart:", error);
    });
};

window.removeTrailingZeros = () => {
  document.querySelectorAll('.rc-right .strike, .rc-right strong').forEach(function(el) {
      let text = el.innerText;
      text = text.replace(/(\.00)(?!\d)/g, '');
      el.innerText = text;
  });
}



subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  console.log('Variant changed!');
  console.log(event.data.variant);
});

async function isFreeProductInCart1(variantId,productId) {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return cart.items.some(item => item.id == variantId);
    //  return cart.items.some(item =>

    //   item.id == variantId &&
    //   item.properties?._gifts_product === 'allgift_' + productId

    // );
  } catch (e) {
    console.error("Cart check error:", e);
    return false;
  }
}

async function onetimeFreeProductInCart1(variantId) {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    return cart.items.some(item =>
      item.id == variantId &&
      item.properties?._free_gift === "true"
    );
  } catch (e) {
    console.error(e);
    return false;
  }
}